// ----------------------------------------------------------------------
import { useLocation } from 'react-router-dom';
import typography from '../typography';

export default function CssBaseline(theme) {
    const { pathname } = useLocation();
    const isHome = pathname === '/';

    return {
        MuiCssBaseline: {
            styleOverrides: {
                '*': {
                    margin: 0,
                    padding: 0,
                    boxSizing: 'border-box',
                },
                html: {
                    width: '100%',
                    height: '100%',
                    WebkitOverflowScrolling: 'touch',
                },
                body: {
                    width: '100%',
                    height: '100%',
                    backgroundColor: isHome ? theme.palette.grey[800] : 'inherit',
                },
                '#root': {
                    width: '100%',
                    height: '100%',
                },
                input: {
                    '&[type=number]': {
                        MozAppearance: 'textfield',
                        '&::-webkit-outer-spin-button': {
                            margin: 0,
                            WebkitAppearance: 'none',
                        },
                        '&::-webkit-inner-spin-button': {
                            margin: 0,
                            WebkitAppearance: 'none',
                        },
                    },
                },
                img: {
                    display: 'block',
                    maxWidth: '100%',
                },
                p: {
                    color: theme.palette.text.secondary,
                },
                '.frontend': {
                    h1: {
                        ...typography.h1,
                        margin: 0,
                        fontFamily: typography.fontFamily,
                    },
                    h2: {
                        ...typography.h2,
                        margin: 0,
                        fontFamily: typography.fontFamily,
                    },
                    h3: {
                        ...typography.h3,
                        margin: 0,
                        fontFamily: typography.fontFamily,
                    },
                    h4: {
                        ...typography.h4,
                        margin: 0,
                        fontFamily: typography.fontFamily,
                    },
                    h5: {
                        ...typography.h5,
                        margin: 0,
                        fontFamily: typography.fontFamily,
                    },
                },
                a: {
                    ...typography.body1,
                    fontSize: 'inherit',
                    color: theme.palette.primary.main,
                    margin: 0,
                    fontWeight: 600,
                    fontFamily: typography.fontFamily,
                    textDecoration: 'none',
                    '&:not(.MuiLink-root)': {
                        '&:not(.MuiButton-root)': {
                            '&:hover': {
                                textDecoration: 'underline',
                            },
                        },
                    },
                },
            },
        },
    };
}
